export default "__VITE_ASSET__CN93oGqs__"